import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReportModal from './documents/ReportModal/ReportModal';
import './CompanyReportSearch.css';
// import { InfoOutlined } from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SimpleModal from './common/SimpleModal';
import InfoSection from './InfoSection';
const CompanyReportSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [companySymbol, setCompanySymbol] = useState('');
  const [reportType, setReportType] = useState('');
  const [year, setYear] = useState('');
  const [quarter, setQuarter] = useState('');
  const [maxResults, setMaxResults] = useState(5);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [availableCompanies, setAvailableCompanies] = useState([]);
  const [availableYears, setAvailableYears] = useState([]);
  const [availableQuarters, setAvailableQuarters] = useState([]);
  const [reportTypes] = useState([
    'all', 'annual', 'quarterly', 'financial', 'earnings'
  ]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  // Get backend URL for API calls
  const getBackendUrl = () => {
    // First, try React environment variables
    if (process.env.REACT_APP_BACKEND_URL) {
      return process.env.REACT_APP_BACKEND_URL;
    }

    // Second, try regular environment variables
    if (process.env.BACKEND_URL) {
      return process.env.BACKEND_URL;
    }

    // Third, check if we're running on Firebase Hosting and use Cloud Run backend
    if (typeof window !== 'undefined' && window.location.hostname) {
      const hostname = window.location.hostname;

      if (hostname.includes('firebaseapp.com') ||
        hostname.includes('web.app') ||
        hostname.includes('viraltrade.in') ||
        hostname.includes('viraltrade-19032')) {
        return 'https://viral-trade-backend-1081469852720.asia-south1.run.app';
      }

      // Fourth, check if we're running on Cloud Run and use hardcoded URL
      if (hostname.includes('run.app')) {
        return 'https://viral-trade-backend-1081469852720.asia-south1.run.app';
      }
    }

    // Finally, fallback to localhost for development
    return 'http://localhost:8000';
  };

  const BASE_URL = getBackendUrl();

  useEffect(() => {
    fetchAvailableCompanies();
    fetchAvailableFilters();
  }, []);

  const fetchAvailableCompanies = async () => {
    // Set static list as requested
    try {
      const staticCompanies = [
        { symbol: 'Reliance Industries', name: 'RELIANCE INDUSTRIES' },
        // { symbol: 'Wipro', name: 'Wipro' },
        { symbol: 'Tata Motors', name: 'Tata Motors' },
        { symbol: 'HDFC Bank', name: 'HDFC Bank' },
        { symbol: 'ICICI Bank', name: 'ICICI Bank' },
        { symbol: 'Mahindra & Mahindra LTD', name: 'MAHINDRA & MAHINDRA LTD.' },
        { symbol: 'L&T', name: 'L&T' },
        { symbol: 'ULTRATECH CEMENT', name: 'ULTRATECH CEMENT' },
        { symbol: 'HCLTECH', name: 'HCLTECH' },
        { symbol: 'ADANI ENTERPRISES', name: 'ADANI ENTERPRISES' },
      ];
      const staticAvailableYears = [
        { value: '2022-23', label: '2022-23' },
        { value: '2023-24', label: '2023-24' },
        { value: '2024-25', label: '2024-25' }
      ];

      setAvailableCompanies(staticCompanies);
      setAvailableYears(staticAvailableYears);
    } catch (error) {
      console.error('Failed to set available companies:', error);
    }
  };

  const fetchAvailableFilters = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/company-reports/available-filters`);
      if (response.data.success) {
        const filters = response.data.filters;
        setAvailableQuarters(filters.quarters || []);
      }
    } catch (error) {
      console.error('Failed to fetch available filters:', error);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError('');
    setSearchResults([]);

    try {
      // Prepare payload (POST)
      const company = availableCompanies.find((c) => c.symbol === companySymbol);
      console.log(company)
      const trimmedQuery = searchQuery.trim();
      const payload = {
        query: trimmedQuery || '',
        max_results: maxResults,
        // Send undefined fields as undefined to avoid sending empty keys
        company_symbol: companySymbol || undefined,
        company_name: company?.name || undefined,
        report_type: reportType && reportType !== 'all' ? reportType : undefined,
        year: year || undefined,
        quarter: quarter || undefined,
      };

      const response = await axios.post(
        `${BASE_URL}/api/company-reports/search`,
        payload
      );

      if (response.data.success) {
        setSearchResults(response.data.results);
      } else {
        setError('Search failed. Please try again.');
      }
    } catch (error) {
      console.error('Search error:', error);
      setError(error.response?.data?.detail || 'Search failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleViewReport = (report) => {
    setSelectedReport(report);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedReport(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch {
      return 'Unknown';
    }
  };

  const getReportTypeIcon = (reportType) => {
    switch (reportType?.toLowerCase()) {
      case 'annual': return '📊';
      case 'quarterly': return '📈';
      case 'financial': return '💰';
      case 'earnings': return '📋';
      default: return '📄';
    }
  };

  const getScoreColor = (score) => {
    if (score >= 0.8) return 'high-score';
    if (score >= 0.6) return 'medium-score';
    return 'low-score';
  };

  const openPdf = (report) => {
    // console.log(report)
    window.open(report.firebaseURL, '_blank');
  }

  return (
    <div className="company-report-search">
      <div className="search-header">
        <h2 className='company-report-search-with-icon'>
          Company Report Search{' '}
          <button
            type="button"
            className="info-icon"
            onClick={() => setIsInfoOpen(true)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setIsInfoOpen(true);
              }
            }}
          >
            <InfoOutlinedIcon fontSize="large" aria-hidden="true" />
          </button>
        </h2>
        <p>Search through company reports, financial statements, and corporate documents</p>
      </div>

      <form onSubmit={handleSearch} className="search-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="searchQuery">Search Query</label>
            <input
              type="text"
              id="searchQuery"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="e.g., revenue growth, profit margin, cash flow"
            />
          </div>

          <div className="form-group">
            <label htmlFor="companySymbol">Company Symbol</label>
            <select
              id="companySymbol"
              value={companySymbol}
              onChange={(e) => setCompanySymbol(e.target.value)}
            >
              <option value="">All Companies</option>
              {availableCompanies.map((company, index) => (
                <option key={index} value={company.symbol}>
                  {company.symbol}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="reportType">Report Type</label>
            <select
              id="reportType"
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
            >
              <option value="all">All Types</option>
              {reportTypes.slice(1).map((type) => (
                <option key={type} value={type}>
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="year">Fiscal Year</label>
            <select
              id="year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">All Years</option>
              {availableYears.map((yearOption) => (
                <option key={yearOption.value} value={yearOption.value}>
                  {yearOption.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="quarter">Quarter</label>
            <select
              id="quarter"
              value={quarter}
              onChange={(e) => setQuarter(e.target.value)}
            >
              <option value="">All Quarters</option>
              {availableQuarters.map((quarterOption) => (
                <option key={quarterOption.value} value={quarterOption.value}>
                  {quarterOption.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="maxResults">Max Results</label>
            <select
              id="maxResults"
              value={maxResults}
              onChange={(e) => setMaxResults(parseInt(e.target.value))}
            >
              <option value={3}>3</option>
              <option value={5}>5</option>
              <option value={10}>10</option>
            </select>
          </div>
        </div>

        <button type="submit" className="search-button" disabled={loading}>
          {loading ? '🔍 Searching...' : '🔍 Search Reports'}
        </button>
      </form>

      {error && (
        <div className="error-message">
          <span className="error-icon">❌</span>
          {error}
        </div>
      )}

      {loading && (
        <div className="loading-placeholder">
          <div className="loading-spinner">⏳</div>
          <p>Searching company reports...</p>
        </div>
      )}

      {searchResults.length > 0 && (
        <div className="search-results">
          <div className="results-header">
            <h3>Search Results</h3>
            {/* <p className="results-count">
              Found {searchResults.length} report{searchResults.length !== 1 ? 's' : ''} for "{searchQuery}"
            </p> */}
          </div>

          <div className="results-grid">
            {searchResults.map((report, index) => (
              <div key={report.id || index} className="report-card">
                <div className="report-header">
                  <span className="report-type-icon">
                    {getReportTypeIcon(report.source_pdf)}
                  </span>
                  {/* <div className="report-score">
                    <span className={`score-badge ${getScoreColor(report.search_score)}`}>
                      {Math.round(report.search_score * 100)}%
                    </span>
                  </div> */}
                </div>

                <div className="report-info">
                  <h4 className="company-name">{report.company_name}</h4>
                  <p className="fiscal-year">{report.fiscal_year}</p>
                  <p className="report-summary">
                    {report.overall_summary?.substring(0, 150)}
                    {report.overall_summary?.length > 150 ? '...' : ''}
                  </p>

                  {report.financials && Object.keys(report.financials).length > 0 && (
                    <div className="financial-highlights">
                      <h5>Key Financials:</h5>
                      <div className="financial-grid">
                        {report.financials.total_revenue && (
                          <span className="financial-item">
                            Revenue: {report.financials.total_revenue}
                          </span>
                        )}
                        {report.financials.net_profit && (
                          <span className="financial-item">
                            Net Profit: {report.financials.net_profit}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="report-meta">
                    <span className="meta-item">
                      📅 {formatDate(report.analysis_date || report.created_at)}
                    </span>
                    {report.source_pdf && (
                      // <span className="meta-item">
                        <button className='meta-item' onClick={()=>openPdf(report)}>📄 {report.source_pdf}</button>
                      // </span>
                    )}
                    {report.is_mock_data && (
                      <span className="meta-item mock-data">
                        🎭 Mock Data
                      </span>
                    )}
                  </div>
                </div>

                <div className="report-actions">
                  <button
                    className="view-report-btn"
                    onClick={() => handleViewReport(report)}
                  >
                    View Report Summary
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {!loading && searchResults.length === 0 && searchQuery && !error && (
        <div className="no-results">
          <div className="no-results-icon">🔍</div>
          <h3>No Results Found</h3>
          <p>No company reports found for "{searchQuery}". Try adjusting your search criteria.</p>
        </div>
      )}

      {/* Report Modal */}
      <ReportModal
        isOpen={isModalOpen && selectedReport}
        onClose={closeModal}
        data={selectedReport}
      />

      {/* Info Modal */}
      <SimpleModal isOpen={isInfoOpen} onClose={() => setIsInfoOpen(false)} title="How to Use">
        <InfoSection />
      </SimpleModal>
    </div>
  );
};

export default CompanyReportSearch;
